import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { BankType, BrandType, NegotiationOption, OutDebt, OutDebtFieldsFragment } from '../generated/graphql';

type ContentInstallmentsPlanBbvaType = {
  gT: (key: string, context?: DictionaryContextType) => string,
  outDebt: OutDebt,
  negOption?: NegotiationOption,
  outDebts?: Array<OutDebtFieldsFragment>
};

enum Normative026RawKeys {
  Relief = 'alivio',
  Modified = 'modificado',
  Reestructured = 'reestructurado',
}

enum BbvaInstallmentsPlanKeys {
  General = 'negotiation_InstallmentsPlan_consequences',
  Relief = 'negotiation_InstallmentsPlan_consequences_relief',
  Modified = 'negotiation_InstallmentsPlan_consequences_modified',
  Reestructured = 'negotiation_InstallmentsPlan_consequences_reestructured',
  Multidebt = 'negotiation_InstallmentsPlan_consequences_multidebt',
}

export const getContentInstallmentsPlanBbva = (props : ContentInstallmentsPlanBbvaType) => {
  const { gT, outDebt, outDebts } = props;
  const keys = [ gT(BbvaInstallmentsPlanKeys.General) ];
  const normative026 = outDebt?.extra?.normative026Raw?.toLowerCase();

  if (normative026?.includes(Normative026RawKeys.Relief)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Relief));
  }
  if (normative026?.includes(Normative026RawKeys.Reestructured)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Reestructured));
  }
  if (normative026?.includes(Normative026RawKeys.Modified)) {
    keys.push(gT(BbvaInstallmentsPlanKeys.Modified));
  }

  if (outDebts && outDebts.filter(
    ({ bank, brand }) => bank === BankType.Bbva && brand === BrandType.Tranquiapp,
  ).length > 1) keys.push(gT(BbvaInstallmentsPlanKeys.Multidebt));

  return keys.join('\n');
};
